module.exports = __webpack_public_path__ + "e9a373241f1773beac70a3d5685f355f.svg";